module.exports = __webpack_public_path__ + "static/img/ROUPS24V_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/ROUPS24V_1.png
// module id = DK2Y
// module chunks = 0